import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Box, Typography, makeStyles } from '@material-ui/core'
import CircularProgress, {
    CircularProgressProps,
} from '@material-ui/core/CircularProgress'
import clsx from 'clsx'
import React from 'react'

const useStyle = makeStyles(() => ({
    meterCirleLowValueColor: {
        color: '#ffb5b5',
    },
    meterCirleMidValueColor: {
        color: '#c2caf2',
    },
    meterCirleHighValueColor: {
        color: '#c2dfc9',
    },
    meterCirleFillLowValueColor: {
        color: '#eb5757',
    },
    meterCirleFillMidValueColor: {
        color: '#8590c8',
    },
    meterCirleFillHighValueColor: {
        color: '#71a87e',
    },
    meterCirleFill: {
        position: 'absolute',
        left: 0,
        '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
        },
    },
    meterLabelContainer: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    meterLabelText: {
        fontSize: pxToRem(24),
    },
    meterLabelLowValueColor: {
        color: '#b50808',
    },
    meterLabelMidValueColor: {
        color: '#383D54',
    },
    meterLabelHighValueColor: {
        color: '#4b7b57',
    },
}))
interface ImportGuideMeterStyleProps {
    value?: number
}
export interface ImportGuideMeterProps {
    value?: number
    label?: string
}
const ImportGuideMeter: React.FC<
    CircularProgressProps & ImportGuideMeterProps
> = (props) => {
    const classes = useStyle({
        value: props.value,
    })
    return (
        <Box style={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
                classes={{
                    circle:
                        (props?.value as number) > (2 / 3) * 100
                            ? classes.meterCirleHighValueColor
                            : (props?.value as number) > (1 / 3) * 100
                            ? classes.meterCirleMidValueColor
                            : classes.meterCirleLowValueColor,
                }}
                size={100}
                {...props}
                value={100}
                aria-label="Import meter circle"
            />
            <CircularProgress
                classes={{
                    circle:
                        (props?.value as number) > (2 / 3) * 100
                            ? classes.meterCirleFillHighValueColor
                            : (props?.value as number) > (1 / 3) * 100
                            ? classes.meterCirleFillMidValueColor
                            : classes.meterCirleFillLowValueColor,
                }}
                className={classes.meterCirleFill}
                size={100}
                {...props}
                aria-label="Import meter value fill"
            />
            <Box className={classes.meterLabelContainer}>
                <Typography
                    className={clsx(
                        classes.meterLabelText,
                        (props?.value as number) > (2 / 3) * 100
                            ? classes.meterLabelHighValueColor
                            : (props?.value as number) > (1 / 3) * 100
                            ? classes.meterLabelMidValueColor
                            : classes.meterLabelLowValueColor
                    )}
                    variant="caption"
                    component="div"
                >
                    {props.label}
                </Typography>
            </Box>
        </Box>
    )
}

export default ImportGuideMeter
